<app-button
    [icon]="['fas', 'xmark']"
    [iconPosition]="IconPosition.END"
    [iconSize]="'sm'"
    [label]="filter().name"
    [matTooltip]="filter().name"
    [type]="isInDropDown() ? ButtonType.DROPDOWN_ITEM : ButtonType.FIXED_WIDTH_BUTTON"
    (onClick)="disableFilter()" />
